import { z } from 'zod';
import { StrengthTraitSlugListSchema } from './strength-traits';

/** Саморефлексия участника по конкретному мероприятию (чистый лист на каждом событии). */
export const EventSelfReflectionDto = z.object({
  eventId: z.uuid(),
  note: z.string().max(2000),
  strengthSlugs: StrengthTraitSlugListSchema,
  updatedAt: z.iso.datetime(),
});

export type EventSelfReflectionDto = z.infer<typeof EventSelfReflectionDto>;

export const UpsertEventSelfReflectionInput = z.object({
  note: z.string().max(2000),
  strengthSlugs: StrengthTraitSlugListSchema,
});

export type UpsertEventSelfReflectionInput = z.infer<typeof UpsertEventSelfReflectionInput>;
